export default __webpack_public_path__ + "static/media/Astrum.af5702c4.jpg";